












































































































import {Component, Vue} from 'vue-property-decorator';
import {ModuleShop} from '@/store/modules/ShopModule';
import {uploadFile} from '@/services/UploadFileService';
import {LayoutModule, NotificationType} from '@/store/modules/LayoutModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';


@Component({})
export default class UploadFileBtn extends Vue {
  files: any = null;
  dialog: boolean = false;
  loading: boolean = false;
  subDialog: boolean = false;
  listOrdersProcessing = [];

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  async uploadFile() {
    try {
      this.loading = true;
      const res = await uploadFile(this.organizationId, this.shopId, this.files);
      if (res.status === 200) {
        LayoutModule.showNotification({text: 'Success'});
        this.listOrdersProcessing = res.data.data;
        this.subDialog = true;
      } else {
        LayoutModule.showNotification({text: res.data.message, type: NotificationType.ERROR});
      }
      this.files = null;
      this.dialog = false;
    } catch (e) {
      LayoutModule.showNotification({text: e, type: NotificationType.ERROR});
    } finally {
      this.loading = false;
    }
  }

  close() {
    this.files = null;
    this.dialog = false;
  }
}
